<!--
 * @Author: wangpeng wangpeng@bailongma-inc.com
 * @Date: 2024-09-30 15:07:30
 * @LastEditors: wangpeng wangpeng@bailongma-inc.com
 * @LastEditTime: 2024-10-23 20:31:28
 * @FilePath: /pages/organize/department/components/employee/components/detailDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <QsDrawer
    title="批量调整部门"
    :visible.sync="visible"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <div class="content">
      <div class="content-title">{{ title }}</div>
      <div class="content-tagbox">
        <el-tag
          v-for="item in staffs"
          closable
          :key="item.id"
          @close="removeStaff(item)"
          >{{ item.userName }}</el-tag
        >
      </div>
      <el-form :model="formData" ref="formRef" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <DeptSelector
              v-model="formData.deptId"
              label="所属部门调整至"
              prop="deptId"
              :isAll="true"
              :multiple="false"
              @selectedNodesChange="handleDeptChange"
            />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </template>
  </QsDrawer>
</template>
<script setup>
import { ref, reactive, computed } from 'vue'
import { Message } from '@qs/ui'
import { pickBy } from 'lodash'
import { setDept } from '@/api/domain/organize'
import DeptSelector from '@/components/DeptSelect/WithLabel.vue'

const emits = defineEmits(['refresh'])
const visible = ref(false)
const staffs = ref([])
const title = computed(() => `员工姓名（共 ${staffs.value.length} 人）`)
const formRef = ref(null)
const rules = ref({
  deptId: [{ required: true, message: '请选择部门', trigger: 'blur' }],
})

// 表单数据
const formData = reactive({
  deptId: '',
})

const openDrawer = (userIdList) => {
  staffs.value = userIdList
  visible.value = true
}
const closeDrawer = () => {
  visible.value = false
}

const handleClose = () => {
  formRef.value.resetFields()
  staffs.value = []
  formData.deptId = ''
  changedDept.value = null
  closeDrawer()
}

// 移除员工
const removeStaff = (staff) => {
  staffs.value = staffs.value.filter((item) => item.id !== staff.id)
  if (staffs.value.length === 0) {
    handleClose()
  }
}

const changedDept = ref(null)
const handleDeptChange = (dept) => {
  changedDept.value = dept
}

const handleSave = async () => {
  const valid = await formRef.value.validate()
  if (!valid) return
  const params = {
    userIdList: staffs.value.map((item) => item.id),
    ...formData,
  }
  const { code } = await setDept(pickBy({ ...params }))
  if (code === 1) {
    Message.success('批量调整成功')
    emits('refresh', changedDept.value?.[0])
    handleClose()
  }
}

defineExpose({
  open: openDrawer,
  close: closeDrawer,
})
</script>
<style scoped lang="scss">
::v-deep(.el-select--small) {
  width: 100% !important;
}
::v-deep(.el-form-item .el-form-item__label) {
  justify-content: flex-start;
}
::v-deep(.el-tag--small) {
  padding: 2px 8px;
  font-size: 14px;
  font-weight: normal;
  height: 24px;
  margin-bottom: 8px;
  margin-right: 8px;
}

.content-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  display: flex;
  align-items: center;
  letter-spacing: 0em;
  /* 信息/font-black2 */
  /* 样式描述：次强调信息 */
  color: rgba(0, 0, 0, 0.6);
}
.content {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  transform: scale(1);
  > .content-tagbox {
    margin-top: 8px;
  }
}
</style>
